import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

type Entity = models.FiltroCargaDescargaEAD;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

const Limite = SelectorSimpleFactory([25, 50, 100, 200, 500, 1000, 2000], x => x, x => "" + x);

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class FiltroCargaDescargaEADComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Status = getField(selectores.StatusCargaDescarga);
        const Camion = getField(selectores.CamionEAD);
        const Sucursal = getField(selectores.Sucursal);
        const Chofer = getField(selectores.ChoferEAD);
        const Usuario = getField(selectores.Usuario);
        const Ruta = getField(selectores.RutaEAD);
        const Date = getField(kea.DateTime);
        const SiNo = getField(selectores.SiNo);
        const Lim = getField(Limite);
        return (
            <div>
                {kea.autogrid(3, [
                    <Status field="Status" label="Status" />,
                    <Camion field="IdCamion" label="Camión" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Chofer field="IdChofer" label="Chofer" />,
                    <Usuario field="IdUsuario" label="Usuario" />,
                    <Ruta field="IdRutaEAD" label="Ruta" />,
                    <Date field="FechaInicioFinal" label="Fecha inicio (inicio)" />,
                    <Date field="FechaInicioFinal" label="Fecha inicio (final)" />,
                    <SiNo field="TieneServiciosIncluidos" label="Servicios incluidos" />,
                    <SiNo field="TieneGuiasIncompletas" label="Guias incompletas" />,
                    <Lim field="Limite" label="Límite:" />,                    
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasEAD/list/filtro.tsx